<script>
import { mapGetters } from "vuex";
import { resolveUploadUrl } from "@/helpers/api";

/**
 * Authorised signatory band — auto-spans 1 to 4 columns based on how many
 * signatories the print profile defines for the given voucher type. Each
 * signatory may have an optional signature image (resolved through the API
 * upload base URL so server-side Chromium can fetch it).
 *
 * Filtered by voucher type — a signatory with `showOnVoucherTypesCsv` is
 * shown only when `voucherType` is listed (empty CSV = all).
 */
export default {
  name: "PrintSignatoryBlock",
  props: {
    voucherType: { type: String, default: null },
    maxColumns: { type: Number, default: 4 },
  },
  computed: {
    ...mapGetters("printProfile", { signatories: "signatories" }),
    visibleSignatories() {
      const t = this.voucherType;
      return (this.signatories || []).filter((s) => {
        if (!s.showOnVoucherTypesCsv) return true;
        if (!t) return true;
        return s.showOnVoucherTypesCsv.split(",").map((x) => x.trim()).includes(t);
      });
    },
    columns() {
      const n = this.visibleSignatories.length || 1;
      return Math.min(n, this.maxColumns);
    },
    bandClass() {
      return `cols-${this.columns}`;
    },
  },
  methods: {
    imageUrl(path) {
      return path ? resolveUploadUrl(path) : null;
    },
  },
};
</script>

<template>
  <div v-if="visibleSignatories.length" class="print-signatory-band" :class="bandClass">
    <div v-for="s in visibleSignatories" :key="s.id" class="print-signatory">
      <img
        v-if="s.signatureImagePath"
        class="print-signatory-image"
        :src="imageUrl(s.signatureImagePath)"
        :alt="s.name"
      />
      <div class="print-signatory-name">{{ s.name }}</div>
      <div class="print-signatory-designation">{{ s.designation }}</div>
    </div>
  </div>
</template>
